import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

const MOBILE_HEADER_HEIGHT = 12;

export const Container = styled.div`
  max-width: 64.75rem;
  margin: 0 auto;
  padding-bottom: 2.5rem;
`;

export const ProductsCount = styled.div`
  ${theme.typography.labelRegular400}
  color: ${theme.color.text.tertiary};
  margin-bottom: 0.5rem;
  padding-inline: 1rem;
  padding-top: ${MOBILE_HEADER_HEIGHT}px; // cuz of sticky header - otherwise it would be hidden under header

  display: flex;
  align-items: center;
  gap: 4px;

  @media (min-width: ${breakpoints.md}) {
    margin-bottom: 0.75rem;
    margin-top: 1.5rem;
    padding-top: 0;
  }
`;

export const StickyWrapper = styled.div`
  position: sticky;
  top: ${MOBILE_HEADER_HEIGHT}px;
  z-index: 10;
  background-color: ${theme.color.background.primary};

  @media (min-width: ${breakpoints.lg}) {
    top: 0;
  }
`;

export const Divider = styled.div<{
  hideOnDesktop?: boolean;
  isScrolled?: boolean;
}>`
  width: 100%;
  padding-bottom: 0.5rem;
  box-shadow: 0px 2px 4px 0px rgba(71, 71, 71, 0.1),
    0px 1px 2px 0px rgba(71, 71, 71, 0.06);

  @media (min-width: ${breakpoints.md}) {
    position: relative;
    left: 50%;
    translate: -50% 0;
    width: ${({ isScrolled }) => (isScrolled ? '100vw' : 'calc(100% - 2rem)')};

    box-shadow: ${({ isScrolled }) =>
      isScrolled
        ? '0px 2px 3px 0px rgba(71, 71, 71, 0.04), 0px 3px 4px 0px rgba(71, 71, 71, 0.08)'
        : `0 1px 0 0 ${theme.color.border.divider}`};

    display: ${({ hideOnDesktop }) => (hideOnDesktop ? 'none' : 'block')};
  }
`;
